import {
    useDispatch,
    useSelector,
} from 'react-redux';

import type {
    AppDispatch,
    RootState,
} from '../store';

/**
 * Typed replacements for the bare react-redux hooks (FNP-951).
 *
 * Use these throughout the app instead of `useDispatch` / `useSelector` so
 * state is typed as RootState and a typo in a slice key is a compile error
 * rather than an `undefined` at runtime.
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
